module.exports = __webpack_public_path__ + "static/img/technology7.e10ed51c.png";